import { Chip } from '@design-system/components/chip/chip';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

type PaymentStatusProps = {
  paidAt?: string;
};

export const PaymentStatus: React.FC<PaymentStatusProps> = ({ paidAt }) => {
  const done = !!paidAt;
  const label = done ? 'Paid' : 'Not Paid';

  return (
    <Chip
      label={label}
      className={clsx(
        'rounded-[40px]',
        !done && sprinkles({ bg: 'WARNING-900', color: 'W-100' }),
        done && sprinkles({ bg: 'G-60', color: 'W-100' }),
      )}
      disabled
    />
  );
};
